import React, { useEffect, useRef, useState } from 'react';
import 'bootstrap-select';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SystemParameterService from 'service/SystemParameterService';
import LoadingSpinner from 'component/LoadingSpinner';
import { SystemParameterCreateReq } from 'domain/payload/request/systemParameter/SystemParameterCreateReq';
import { SystemParameterUpdateReq } from 'domain/payload/request/systemParameter/SystemParameterUpdateReq';

const SystemParameterForm: React.FC = () => {
  const { id } = useParams();
  const { profile } = useSelector((state: any) => state.auth);

  const canvasRef = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();

  const systemParameterService = SystemParameterService();

  // INPUT STATE
  const [parameter, setParameter] = useState('');
  const [description, setDescription] = useState('');
  const [vgroup, setVgroup] = useState('');
  const [svalue, setSvalue] = useState('');

  // LOADING
  const [isLoadingDetail, setIsLoadingDetail] = useState(false);
  const [isLoadingSave, setIsLoadingSave] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    setIsLoadingSave(true)
    try {
      if (id == "0") {
        await systemParameterCreate()
        alert(`Data ${parameter} successfully created!`)
        navigate("/system-parameter")
      } else {
        await systemParameterUpdate()
        alert(`Data ${parameter} successfully updated!`)
        navigate("/system-parameter")
      }
      setIsLoadingSave(false)
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat menyimpan data';
      alert(`Error: ${errorMessage}`);
      setIsLoadingSave(false)
    }
  };

  const fetchDetail = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    setIsLoadingDetail(true)
    try {
      const res = await systemParameterService.systemParameterDetail(token, id ?? "0");
      console.log(res)
      setParameter(res.data?.parameter!)
      setDescription(res.data?.description!)
      setVgroup(res.data?.vgroup!)
      setSvalue(res.data?.svalue!)

      setIsLoadingDetail(false)
    } catch (err: any) {
      console.error(err);
      const errorMessage = err.response?.data?.message || err.message || 'Terjadi kesalahan saat mengambil detail system parameter';
      window.alert(`Error: ${errorMessage}`);
      setIsLoadingDetail(false)
    }
  };

  const systemParameterCreate = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    try {
      var request: SystemParameterCreateReq = {
        parameter: parameter,
        description: description,
        vgroup: vgroup,
        svalue: svalue
      }

      console.log(request)

      await systemParameterService.systemParameterCreate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  const systemParameterUpdate = async () => {
    const token = profile?.data.token;
    if (!token) {
      window.alert('Token tidak ditemukan. Silakan login kembali.');
      return;
    }

    try {
      var request: SystemParameterUpdateReq = {
        id: id!,
        description: description,
        svalue: svalue
      }

      console.log(request)

      await systemParameterService.systemParameterUpdate(token, request);
    } catch (err) {
      console.error(err);
      throw err
    }
  }

  useEffect(() => {
    if (id != "0") {
      fetchDetail()
    }
  }, [])

  return (

    <div className="pt-1 h-100" style={{ background: '#f2f4f8' }}>
      <div className="m-4">
        <h4 className="mb-4">{id == "0" ? "Add SystemParameter" : "Edit SystemParameter"}</h4>
        <div className="p-4" style={{ background: 'white' }}>
          {
            isLoadingDetail ?
              <LoadingSpinner />
              :
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label fw-semibold">Parameter</label>
                        <input
                          type="text"
                          id="name"
                          className="form-control form-control-compact"
                          value={parameter}
                          placeholder="Name"
                          onChange={(e) => setParameter(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="name" className="form-label fw-semibold">Description</label>
                        <input
                          type="text"
                          id="description"
                          className="form-control form-control-compact"
                          value={description}
                          placeholder="Description"
                          onChange={(e) => setDescription(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className='col-sm-6'>
                     <div>
                        <div className="mb-3">
                        <label htmlFor="vgroup" className="form-label fw-semibold">Vgroup</label>
                        <input
                          type="text"
                          id="vgroup"
                          className="form-control form-control-compact"
                          value={vgroup}
                          placeholder="Vgroup"
                          onChange={(e) => setVgroup(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="remarks" className="form-label fw-semibold">Svalue</label>
                        <textarea
                          id="remarks"
                          className="form-control form-control-compact"
                          rows={3}
                          value={svalue}
                          placeholder="Svalue"
                          onChange={(e) => setSvalue(e.target.value)}
                          required
                        />
                      </div>
                     </div>
                  </div>

                  <div className="mb-4" />

                </div>

                <div className="w-100 d-flex justify-content-end">
                  <Link to="/system-parameter">
                    <button className="btn btn-outline-primary">Cancel</button>
                  </Link>
                  <button type="submit" className="btn btn-primary d-flex justify-content-center align-items-center ms-2" disabled={isLoadingSave}>
                    {
                      isLoadingSave &&
                      <>
                        <LoadingSpinner reverse={true} />
                        <p className="ms-2"></p>
                      </>
                    }
                    Save
                  </button>
                </div>
              </form>
          }
        </div>
      </div>
    </div>
  );

};

export default SystemParameterForm;